import http from "./http";
import { sprintf } from "sprintf-js";

import { RECENT_API_ENDPOINT } from "./endpoints";

export const addToRecent = (worldId, challengeId) => {
  return http.get(sprintf(RECENT_API_ENDPOINT, { worldId, challengeId }));
};
